import React, { useRef, useEffect } from 'react';
import image1 from '../../assets/images/parallaxImage1.png';
import image2 from '../../assets/images/parallaxImage2.png';
import image3 from '../../assets/images/parallaxImage3.png';
import baulogo from '../../assets/logos/bau.webp';
import bdesignlogo from '../../assets/logos/BDesign.webp';
// import hbytalalogo from '../../assets/logos/hbytala.avif';
import hbytalalogo from '../../assets/logos/talawhitelogo.png'
import profitpulselogo from '../../assets/logos/profit-pulse.webp';
import riselogo from '../../assets/logos/rise.webp';
import zboonlogo from '../../assets/logos/zboon.webp';


import './Feature.css';

const Feature = () => {
  const containerRef = useRef(null);
  const imagesRef = useRef([]);

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const rect = containerRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const centerY = rect.top + rect.height / 2;
      const scrollProgress = 1 - centerY / windowHeight;

      const clampedProgress = Math.max(-1, Math.min(1, scrollProgress));

      imagesRef.current.forEach((img, index) => {
        if (!img) return;

        const baseTranslate = [40, 80, 40]; // How far each image should move
        const baseScale = [0.95, 1, 0.95];  // Base size of each image
        const scaleBoost = 0.15;

        const translateY = clampedProgress * -baseTranslate[index];
        const scale = baseScale[index] + clampedProgress * scaleBoost;

        img.style.transform = `
          translateY(${translateY}px)
          scale(${scale})
        `;
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="feature-section" ref={containerRef} id="features">
      <div className="feature-container">
        <div className="feature-content">
          <h2 className="feature-title">Our Partners</h2>

          <div className="logo-marquee">
            <div className="logo-track">
              <div className="logo-item"><img src={bdesignlogo} alt="BDesign" /></div>
              <div className="logo-item"><img src={hbytalalogo} alt="Hbytala" /></div>
              {/* <div className="logo-item"><img src={zboonlogo} alt="Zboon" /></div> */}
              <div className="logo-item"><img src={baulogo} alt="BAU" /></div>
              <div className="logo-item"><img src={riselogo} alt="Rise" /></div>
              <div className="logo-item"><img src={profitpulselogo} alt="Profit Pulse" /></div>

              {/* <!-- Repeat the same logos again to ensure smooth infinite loop --> */}
              <div className="logo-item"><img src={bdesignlogo} alt="BDesign" /></div>
              <div className="logo-item"><img src={hbytalalogo} alt="Hbytala" /></div>
              {/* <div className="logo-item"><img src={zboonlogo} alt="Zboon" /></div> */}
              <div className="logo-item"><img src={baulogo} alt="BAU" /></div>
              <div className="logo-item"><img src={riselogo} alt="Rise" /></div>
              <div className="logo-item"><img src={profitpulselogo} alt="Profit Pulse" /></div>
            </div>
          </div>

        </div>
        <div className="feature-images">
          <div className="feature-image left-image" ref={el => (imagesRef.current[0] = el)}>
            <img src={image1} alt="Gemini AI Assistant" />
          </div>
          <div className="feature-image center-image" ref={el => (imagesRef.current[1] = el)}>
            <img src={image2} alt="VS Code" />
          </div>
          <div className="feature-image right-image" ref={el => (imagesRef.current[2] = el)}>
            <img src={image3} alt="Mobile App" />
          </div>
        </div>

      </div>
    </section>
  );
};

export default Feature;
